import { render, staticRenderFns } from "./GenerateArtistDialog.vue?vue&type=template&id=4e138700&scoped=true"
import script from "./GenerateArtistDialog.vue?vue&type=script&lang=js"
export * from "./GenerateArtistDialog.vue?vue&type=script&lang=js"
import style0 from "./GenerateArtistDialog.vue?vue&type=style&index=0&id=4e138700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e138700",
  null
  
)

export default component.exports